import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col, Affix, Drawer } from "antd";

import Controls from "./Controls/Controls";
import Sidebar from "../../components/OrderCard/sidebar/sidebar";

/* todo перенесено из offer */
import FormOrderCard from "../../components/OrderCard/OrderCreateAndEdit";
import progresses from "../../../common/FormProgress/orderProgresses";
import FormProgress from "../../../common/FormProgress/FormProgress";
/* end todo */

import {
  getOrderById,
  createOrder,
  updateOrder,
  archieveOrder,
  createOrderClearError,
  downloadContractByOrderId,
  downloadNotificationToGibdd
} from "../../redux/actions/orderCard";

import { getDrivers } from "../../../../Employees/redux/actions/profiles";
import { getAllVehicles } from "../../../../Transport/redux/actions/vehiclesActions";
import { createTemplate } from "../../../../Templates/redux/actions/templateCard";
import { interfaceActions } from "../../../../../common/redux/actions";
import * as URLs from "../../../../../common/constants/systemUrls";
import BtnCloseEditing from "../../components/OrderCard/buttons/BtnCloseEditing";
import BtnFormSubmit from "../../components/OrderCard/buttons/BtnFormSubmit";
import setTemplateToForm from "../../../common/setTemplateToForm/setTemplateToForm";
import history from "../../../../../common/history";
import { getNumberWithoutSpaces } from "../../../../../common/utils/format";

import showFailureModal from "../../../../../common/components/failureModal/failureModal";
import {
  failureOfferVehicles,
  failureOfferDrivers
} from "../../../Request/components/RequestCard/common/modal/failureModal/FailureModal";
import "./OrderCard.css";
import OrderReport from "../../components/OrderCard/OrderReport/OrderReport";
import { YMaps } from "react-yandex-maps";

const { setCaption } = interfaceActions;

class OrderCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderId: this.getOrderId(),
      isEditable: false,
      formProgress: [...progresses.default],
      disabledSaveButton: true,
      errActiveVehicleAndDriver: false,
      orderReportDrawerVisible: false,
      showAllFields: false,
      ymaps: false
    };

    if (this.state.orderId === 0) {
      this.state.isEditable = true;
    }

    this.forms = {};
  }

  // Вытаскиваем OrderId
  // todo если он равняется 'add' возвращаем 0 добавление нового заказа
  getOrderId() {
    let { id = 0 } = this.props.match && this.props.match.params;
    id = Number(id);
    return id > 0 ? id : 0;
  }

  setCaption(flagUpdate = false) {
    if (flagUpdate) {
      let title = "";
      let breadCrumbs = null;
      if (this.state.orderId === 0) {
        title = `Формирование Заказа`;
      } else {
        const { order } = this.props;
        if (order) {
          title =
            (order.orderName ? `${order.orderName} - ` : "") +
            getNumberWithoutSpaces(order.number);
          if (this.state.isEditable) {
            breadCrumbs = title;
            title = "Редактирование заказа";
          }
        }
      }

      if (title) {
        this.props.setCaption({
          enabled: true,
          mainCaption: `${title} ${
            this.props.match.params.id === "add_no_freight"
              ? "(Без формирования договора фрахтования)"
              : ""
          }`,
          breadCrumbs: [
            {
              path: "/" + URLs.CONTROL_PANEL,
              breadcrumbName: "Панель управления"
            },
            { path: "/" + URLs.ORDER, breadcrumbName: "Исполнительство" },
            {
              path: "/" + URLs.COMPANY,
              breadcrumbName: breadCrumbs ? breadCrumbs : title
            }
          ]
        });
      }
    }
  }

  // todo быстрое решение для проверки актиных водителей и ТС
  checkActiveVehicleAndDriver() {
    if (!this.state.errActiveVehicleAndDriver) {
      if (
        !this.props.activeVehicle.isLoading &&
        this.props.activeVehicle.actualVehicles &&
        this.props.activeVehicle.actualVehicles.length === 0
      ) {
        showFailureModal(failureOfferVehicles());
        this.setState({ errActiveVehicleAndDriver: true });
      } else if (
        !this.props.activeDrivers.isLoading &&
        this.props.activeDrivers.drivers &&
        this.props.activeDrivers.drivers.length === 0
      ) {
        showFailureModal(failureOfferDrivers());
        this.setState({ errActiveVehicleAndDriver: true });
      }
    }
  }

  updateOrderId() {
    const orderId = this.getOrderId();
    if (orderId !== this.state.orderId) {
      if (orderId > 0) {
        this.props.getOrderById(orderId);
      }
      this.setState(state => ({
        orderId,
        isEditable: orderId === 0 ? true : state.isEditable
      }));
    }
  }

  componentDidMount() {
    this.setCaption(true);
    if (this.state.orderId > 0) {
      this.props.getOrderById(this.state.orderId);
    } else {
      // todo быстрое решение для проверку активных ТС и водителей
      this.props.getDrivers();
      this.props.getAllVehicles();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateOrderId(); // Смотрим не сменился ли OrderId
    this.setCaption(this.props.order !== prevProps.order && this.props.order);
    if (this.state.orderId === 0) {
      this.checkActiveVehicleAndDriver();
    }
  }

  handleClickEdit = () => {
    this.setState(
      state => ({
        isEditable: true
      }),
      () => {
        this.setCaption(true);
      }
    );
  };

  handleBackButton = () => {
    this.props.history.goBack();
  };

  handleClickDelete = status => {
    const { order, archieveOrder } = this.props;
    if (order && order.id) {
      archieveOrder({
        id: order.id,
        status: status
      });
    }
  };

  handleClickClose = () => {
    history.push("/" + URLs.ORDER);
  };

  handleSubmit = () => {
    this.formSubmit("formOrderInfo", fieldsValue => {
      const { orderId } = this.state;
      let data = {
        orderId,
        ...fieldsValue
      };
      if (orderId === 0) {
        this.props.createOrder({ data, ymaps: this.state.ymaps });
      } else {
        this.props.updateOrder(data);
      }
    });
  };

  handleSubmitTemplate = templateName => {
    this.formSubmit("formOrderInfo", fieldsValue => {
      const { orderId } = this.state;
      let data = {
        type: "order",
        orderId,
        templateName,
        ...fieldsValue
      };
      this.props.createTemplate(data);
    });
  };

  setTemplateToForm = data => {
    const form = this.getForm("formOrderInfo");
    if (form) {
      setTemplateToForm(form, data, "order");
    }
  };

  /* todo то что можно вынести в общие компоненты */
  formSubmit = (name, cbSubmit) => {
    const form = this.getForm(name);
    if (form) {
      // e.preventDefault();
      form.validateFields((err, fieldsValue) => {
        // console.log(err, fieldsValue);
        if (err) {
          return false;
        }
        // Отправка формы
        if (cbSubmit) cbSubmit(fieldsValue);
      });
    } else {
      console.log("Error", name);
    }
  };
  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };
  updateProgress = values => {
    const form = this.getForm("formOrderInfo");
    if (form) {
      let newFormProgress = null;
      let checkAll = true;
      console.log(values);
      Object.keys(values).forEach(name => {
        this.state.formProgress.forEach((step, index) => {
          if (step.fields.some(fieldName => fieldName === name) && step.check) {
            const fieldsValue = form.getFieldsValue(step.fields);
            const check = step.check(fieldsValue, form);
            if (!newFormProgress)
              newFormProgress = [...this.state.formProgress];
            newFormProgress = [
              ...newFormProgress.slice(0, index),
              {
                ...newFormProgress[index],
                name: step.name,
                completed: check,
                fieldsValue: fieldsValue
              },
              ...newFormProgress.slice(index + 1)
            ];
            if (checkAll && !check) checkAll = false;
          }
        });
      });

      if (newFormProgress) {
        if (checkAll) {
          // Если все изменённые поля успешно прошли проверку
          // делаем полную проверку по всем группам
          // если button = false тогда он не участвует в проверке для кнопки отправки.
          // если в прогрессе нет ключа button то по умолчанию он равен true
          checkAll = newFormProgress.every(({ completed, button = true }) =>
            button ? completed : true
          );
        }
        this.setState({
          formProgress: newFormProgress,
          disabledSaveButton: !checkAll
        });
      }
    }
  };

  showOrderReportDrawer = () => {
    this.setState({ orderReportDrawerVisible: true });
  };

  closeOrderReportDrawer = () => {
    this.setState({ orderReportDrawerVisible: false });
  };

  handleClickShowAllFields = value => {
    this.setState(state => ({ showAllFields: value }));
  };

  initYmaps(ymaps) {
    this.setState((state, props) => ({
      ymaps: ymaps
    }));
  }

  /* end */

  render() {
    const { order, createErrors, clearError } = this.props; // isLoading
    const typeForm =
      this.state.orderId > 0
        ? this.state.isEditable
          ? "edit"
          : "view"
        : "create";
    // todo разобраться с css классами

    return (
      <div className={"site-wrapper offer-card"}>
        <Row className="offer-card__form-wrap">
          <Col span={18} className="offer-card__form">
            <FormOrderCard
              ref={el => {
                this.componentRef = el;
              }}
              componentRef={this.componentRef}
              name="formOrderInfo"
              typeForm={typeForm}
              setForm={this.setForm}
              order={order}
              orderId={this.state.orderId}
              createErrors={createErrors}
              clearError={clearError}
              showAllFields={this.state.showAllFields}
              handleClickShowAllFields={this.handleClickShowAllFields}
              updateProgress={this.updateProgress}
              isEditable={this.state.isEditable}
              formProgress={this.state.formProgress}
              performers={this.props.performers}
              noFreightOrder={this.props.match.params.id === "add_no_freight"}
            />
          </Col>
          <Col span={6} className="offer-card__status order-card__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById("mainSheet")}
            >
              {typeForm === "view" ? (
                <Sidebar
                  orderId={this.state.orderId}
                  order={order}
                  handleClick={this.handleClickEdit}
                  downloadContractByOrderId={
                    this.props.downloadContractByOrderId
                  }
                  downloadNotificationInGibdd={
                    this.props.downloadNotificationToGibdd
                  }
                  downloadIsLoading={this.props.downloadIsLoading}
                  downloadNotificationIsLoading={
                    this.props.downloadNotificationIsLoading
                  }
                  handleBackButton={this.handleBackButton}
                  handleClickDelete={this.handleClickDelete}
                  showOrderReportDrawer={this.showOrderReportDrawer}
                />
              ) : (
                <Fragment>
                  <BtnFormSubmit
                    onClick={this.handleSubmit}
                    onClickTemplate={this.handleSubmitTemplate}
                    typeForm={typeForm}
                    disabled={this.state.disabledSaveButton}
                  />
                  <div className="offer-card__progress">
                    <FormProgress progress={this.state.formProgress} />
                  </div>
                  <div
                    className="orderCard__btn-close"
                    style={{ marginTop: 16 }}
                  >
                    <BtnCloseEditing handleClick={this.handleClickClose} />
                  </div>
                </Fragment>
              )}
            </Affix>
          </Col>
        </Row>
        {typeForm === "view" && <Controls id={this.state.orderId} />}
        {this.props.order && this.props.order.id && (
          <Drawer
            visible={this.state.orderReportDrawerVisible}
            closable={true}
            onClose={this.closeOrderReportDrawer}
            destroyOnClose={true}
            placement={"left"}
            width={896}
            className={"order-report-drawer"}
          >
            <div className={"drawer-header"}>
              <span className={"drawer-header__title"}>Отчет по заказу</span>
              <span className={"drawer-header__number"}>
                {this.props.order &&
                  this.props.order.number &&
                  getNumberWithoutSpaces(this.props.order.number)}
              </span>
            </div>
            <OrderReport id={this.props.order && this.props.order.id} />
            <div className={"drawer-footer"} />
          </Drawer>
        )}

        <YMaps
          query={{
            apikey: "b6a66b8f-dc2c-4946-a916-0fb0ca680e5a"
          }}
          onApiAvaliable={ymaps => this.initYmaps(ymaps)}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    order: state.Executorship.Orders.orderCard.data,
    createErrors: state.Executorship.Orders.orderCard.createErrors,
    isLoading: state.Executorship.Orders.orderCard.isLoading,
    downloadIsLoading: state.Executorship.Orders.orderCard.downloadIsLoading,
    downloadNotificationIsLoading:
      state.Executorship.Orders.orderCard.downloadNotificationIsLoading,
    activeVehicle: state.Transport.Vehicles.vehicles,
    activeDrivers: state.Employees.profiles,
    performers: state.Common.Filters.performers
  }),
  {
    setCaption,
    getOrderById,
    createOrder,
    updateOrder,
    clearError: createOrderClearError,
    downloadContractByOrderId,
    downloadNotificationToGibdd,
    archieveOrder,
    //todo возмодно потом нужно будет переделать
    getDrivers,
    getAllVehicles,
    createTemplate
  }
)(OrderCard);
